var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "modal_size lg_size",
          class:
            _vm.viewResolution === "view_mobile"
              ? "mob_size"
              : _vm.viewResolution === "view_tablet"
              ? "tab_size"
              : ""
        },
        [
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "javascript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content" }, [
            _c("dt", { staticClass: "ellipsis" }, [
              _c("i", [_vm._v(_vm._s(_vm.$t("BUTTON.NOTICE.PREVIEW")))])
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "in_preview" }, [
              _c("div", { staticClass: "grid_top mt-20" }, [
                _c("fieldset", { staticClass: "ui_fieldset" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selRes,
                            expression: "selRes"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selRes = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.changeResolution
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "pc" } }, [
                          _vm._v("PC")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "tablet" } }, [
                          _vm._v("Tablet")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "mobile" } }, [
                          _vm._v("Mobile")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      staticClass: "text_input w100p",
                      attrs: { type: "text", readonly: "" },
                      domProps: { value: _vm.resMap[_vm.selRes].name }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "preview_wrap scroll" }, [
                _c(
                  "div",
                  { staticClass: "view_cont", class: _vm.viewResolution },
                  [
                    _c("dl", { staticClass: "view_subject" }, [
                      _c("dt", { staticClass: "subject" }, [
                        _vm.detail.IMPORTANCE_YN === "Y"
                          ? _c("em", { staticClass: "textcolor_important" }, [
                              _vm._v(
                                "[" +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                                  "]"
                              )
                            ])
                          : _vm.detail.MUST_READ_YN === "Y"
                          ? _c("em", { staticClass: "textcolor_must" }, [
                              _vm._v(
                                "[" +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.MUSTREAD")) +
                                  "]"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("refTitle")(_vm.detail.KNOWLEDGE_TITLE)
                            ) +
                            "\n                                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "view_desc" }, [
                      _c("div", { staticClass: "tab_wrap preview_tab_wrap" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "tab_menu_02 tab_menus preview_tab_menus"
                          },
                          [
                            _c("li", { staticClass: "on" }, [
                              _c("a", { attrs: { href: "javascript:" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.GLOBAL.DESCRIPTION"))
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab_contents" }, [
                          _c("div", {
                            staticClass: "tab_cont preview_tab_cont",
                            domProps: {
                              innerHTML: _vm._s(_vm.detail.KNOWLEDGE_DESC)
                            }
                          })
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "scroll_btm" }, [
              _c("div", { staticClass: "btn_wrap_full" }, [
                _c("div", { staticClass: "btn_right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c57f996", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c57f996","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/KnowledgePreviewPopup.vue
// module id = dIOf
// module chunks = 0